import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/Card';
import { Button } from '../components/Button';
import { ArrowLeft, Trophy, Filter, Search, ArrowRight } from 'lucide-react';
import { getNationalLeaderboard, scoreColor } from '../data/kpiIntelligence';
export default function KPILeaderboard() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const leaderboard = getNationalLeaderboard(100);
  const filteredLeaderboard = leaderboard.filter(p => p.nama.toLowerCase().includes(searchTerm.toLowerCase()) || p.bindaKode.toLowerCase().includes(searchTerm.toLowerCase()));
  return <div className="space-y-6 animate-in fade-in duration-500 max-w-5xl mx-auto pb-12" data-id="element-1672">
      <div className="flex items-center gap-4 border-b border-border/50 pb-4" data-id="element-1673">
        <Button variant="ghost" size="icon" onClick={() => navigate('/kpi')} className="hover:bg-primary/20 hover:text-primary" data-id="element-1674">
          <ArrowLeft className="w-5 h-5" data-id="element-1675" />
        </Button>
        <div data-id="element-1676">
          <h1 className="text-2xl font-heading font-bold tracking-tight text-foreground flex items-center gap-3" data-id="element-1677">
            LEADERBOARD NASIONAL
            <Trophy className="w-6 h-6 text-primary" data-id="element-1678" />
          </h1>
          <p className="text-muted-foreground font-mono text-xs mt-1 uppercase tracking-widest" data-id="element-1679">
            Top 100 Personel Berkinerja Terbaik
          </p>
        </div>
      </div>

      <div className="flex items-center gap-4 mb-6" data-id="element-1680">
        <div className="relative flex-1 max-w-md" data-id="element-1681">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" data-id="element-1682" />
          <input type="text" placeholder="Cari nama atau kode BINDA..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-9 pr-4 py-2 bg-background/50 border border-border/50 rounded text-xs font-mono focus:outline-none focus:border-primary/50 focus:ring-1 focus:ring-primary/50 transition-all" data-id="element-1683" />
        </div>
      </div>

      <Card className="glass-panel border-border/50" data-id="element-1684">
        <CardHeader className="border-b border-border/50 bg-card/50" data-id="element-1685">
          <CardTitle className="text-sm font-mono uppercase tracking-widest" data-id="element-1686">
            Peringkat Personel
          </CardTitle>
        </CardHeader>
        <CardContent className="p-0" data-id="element-1687">
          <div className="divide-y divide-border/30" data-id="element-1688">
            {filteredLeaderboard.map((p, i) => <div key={p.id} className="flex items-center justify-between p-4 hover:bg-white/5 cursor-pointer transition-colors" onClick={() => navigate(`/kpi/personnel/${p.id}`)} data-id="element-1689">
                <div className="flex items-center gap-4" data-id="element-1690">
                  <div className={`font-mono w-8 text-center text-lg font-bold ${i < 3 ? 'text-primary' : 'text-muted-foreground'}`} data-id="element-1691">
                    #{p.rankNasional}
                  </div>
                  <img src={p.foto} alt={p.nama} className={`w-12 h-12 rounded-full border-2 ${i < 3 ? 'border-primary' : 'border-border/50'}`} data-id="element-1692" />
                  <div data-id="element-1693">
                    <div className="font-bold text-lg" data-id="element-1694">{p.nama}</div>
                    <div className="text-xs font-mono text-muted-foreground" data-id="element-1695">
                      {p.pangkat} // {p.bindaKode} // {p.id}
                      // {p.bindaKode} // {p.id}
                      // {p.id}
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-6" data-id="element-1696">
                  <div className="text-right hidden md:block" data-id="element-1697">
                    <div className="text-[10px] text-muted-foreground uppercase font-mono" data-id="element-1698">
                      Laporan Valid
                    </div>
                    <div className="font-mono font-bold" data-id="element-1699">{p.laporanValid}</div>
                  </div>
                  <div className="text-right" data-id="element-1700">
                    <div className="font-mono font-bold text-2xl" style={{
                  color: scoreColor(p.score)
                }} data-id="element-1701">
                      {p.score}
                    </div>
                    <div className={`text-[10px] font-mono ${p.trend >= 0 ? 'text-green-400' : 'text-red-400'}`} data-id="element-1702">
                      {p.trend >= 0 ? '+' : ''}
                      {p.trend}%
                    </div>
                  </div>
                  <ArrowRight className="w-5 h-5 text-muted-foreground" data-id="element-1703" />
                </div>
              </div>)}
            {filteredLeaderboard.length === 0 && <div className="p-8 text-center text-muted-foreground font-mono text-sm" data-id="element-1704">
                Tidak ada personel yang cocok dengan pencarian.
              </div>}
          </div>
        </CardContent>
      </Card>
    </div>;
}